export default "__VITE_ASSET__CzY_90mI__"